'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import type { SpartanProductAdasModalProps } from '@/app/lcv/components/sections/spartan/products/adas/modal/types';
import { SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID } from '@/app/lcv/components/sections/spartan/products/explore-features/constants';
import { useExploreFeaturesModal } from '@/app/lcv/components/sections/spartan/products/explore-features/useExploreFeaturesModal';
import { buildSpartanExploreFeaturesAdasCard, buildSpartanExploreFeaturesAdasDetail } from '@/app/lcv/contents/spartan/products/shared/explore-features-adas.data';
const SpartanProductExploreFeaturesModal = dynamic(() => import('@/app/lcv/components/sections/spartan/products/explore-features/modal').then(mod => mod.SpartanProductExploreFeaturesModal), {
  ssr: false
});
export const SpartanProductAdasModal = t0 => {
  const $ = _c(19);
  const {
    features,
    imageCover,
    cardOverlayColor
  } = t0;
  let t1;
  if ($[0] !== cardOverlayColor || $[1] !== imageCover.desktop) {
    t1 = buildSpartanExploreFeaturesAdasCard(imageCover.desktop, cardOverlayColor);
    $[0] = cardOverlayColor;
    $[1] = imageCover.desktop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = [t1];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const exploreFeatures = t2;
  let t3;
  if ($[5] !== features || $[6] !== imageCover) {
    t3 = buildSpartanExploreFeaturesAdasDetail({
      features
    }, imageCover);
    $[5] = features;
    $[6] = imageCover;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      [SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID]: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const details = t4;
  let t5;
  if ($[10] !== details || $[11] !== exploreFeatures) {
    t5 = {
      features: exploreFeatures,
      details
    };
    $[10] = details;
    $[11] = exploreFeatures;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    isOpen,
    activeFeature,
    activeDetail,
    closeDetail,
    restoreOpenTargetFocus
  } = useExploreFeaturesModal(t5);
  let t6;
  if ($[13] !== activeDetail || $[14] !== activeFeature || $[15] !== closeDetail || $[16] !== isOpen || $[17] !== restoreOpenTargetFocus) {
    t6 = <SpartanProductExploreFeaturesModal isOpen={isOpen} onClose={closeDetail} onAfterClose={restoreOpenTargetFocus} feature={activeFeature} detail={activeDetail} />;
    $[13] = activeDetail;
    $[14] = activeFeature;
    $[15] = closeDetail;
    $[16] = isOpen;
    $[17] = restoreOpenTargetFocus;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};